import { render } from "./AudienceDetail.vue?vue&type=template&id=ea181cc8&scoped=true"
import script from "./AudienceDetail.vue?vue&type=script&lang=js"
export * from "./AudienceDetail.vue?vue&type=script&lang=js"

import "./AudienceDetail.vue?vue&type=style&index=0&id=ea181cc8&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea181cc8"]])

export default __exports__